(function () {
  var prefetched = new Set();
  var hoverTimers = new WeakMap();
  var delay = 65;

  function shouldPrefetch(anchor) {
    if (!anchor || !anchor.href || prefetched.has(anchor.href)) return false;

    var url;
    try {
      url = new URL(anchor.href, window.location.href);
    } catch (error) {
      return false;
    }

    if (url.origin !== window.location.origin) return false;
    if (url.pathname === window.location.pathname && url.search === window.location.search) return false;
    if (url.hash && url.pathname === window.location.pathname) return false;
    if (url.pathname.indexOf('/cart') === 0) return false;
    if (url.pathname.indexOf('/checkout') === 0) return false;
    if (url.pathname.indexOf('/account') === 0) return false;
    if (url.pathname.indexOf('/search') === 0) return false;
    if (url.pathname.indexOf('/admin') === 0) return false;

    return true;
  }

  function prefetch(anchor) {
    if (!shouldPrefetch(anchor)) return;

    prefetched.add(anchor.href);

    var link = document.createElement('link');
    link.rel = 'prefetch';
    link.href = anchor.href;
    link.as = 'document';
    document.head.appendChild(link);
  }

  function schedule(anchor) {
    if (!shouldPrefetch(anchor) || hoverTimers.has(anchor)) return;

    var timer = window.setTimeout(function () {
      hoverTimers.delete(anchor);
      prefetch(anchor);
    }, delay);

    hoverTimers.set(anchor, timer);
  }

  function cancel(anchor) {
    var timer = hoverTimers.get(anchor);
    if (!timer) return;
    window.clearTimeout(timer);
    hoverTimers.delete(anchor);
  }

  document.addEventListener('mouseover', function (event) {
    var anchor = event.target.closest && event.target.closest('a[href]');
    schedule(anchor);
  }, { passive: true });

  document.addEventListener('mouseout', function (event) {
    var anchor = event.target.closest && event.target.closest('a[href]');
    cancel(anchor);
  }, { passive: true });

  document.addEventListener('touchstart', function (event) {
    var anchor = event.target.closest && event.target.closest('a[href]');
    prefetch(anchor);
  }, { passive: true });
})();
